export default shuffler(Math.random);

export function shuffler(random) {
  return function shuffle(array, i0 = 0, i1 = array.length) {
    let m = i1 - (i0 = +i0);
    while (m) {
      const i = random() * m-- | 0, t = array[m + i0];
      array[m + i0] = array[i + i0];
      array[i + i0] = t;
    }
    return array;
  };
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-array/src/shuffle.js
// module id = null
// module chunks = 